<template>
  <div class="projector">
      <div class="front-wall no-select" :style="{width: frontWallWidth + 'px'}">
        <!-- 以下代码用作投影仪角度 -->
        <div class="screen" :style="{height:StatusHeight + 'px', width: screenWidth + 'px', top:screenStatusTop +'px'}">
            <div class="project-top-w-arrow" v-if="position !== 1">
              <ProjectArrowItem color= '#ff3399' :PjItemWidth='PjscreenWidth'></ProjectArrowItem>
            </div>
             <div class="project-top-v-arrow-r" v-if="position !== 1">
              <ProjectArrowItem :PjItemWidth='screenStatusHeight' color= '#ff3399' isVertical=true></ProjectArrowItem>
            </div>
            <div class="screen-bg">
              <div class="screenHeightBg" :style="{height:InitScreenHeight + 'px', width: screenWidth + 'px'}" v-if="screenStatus.top < 0"></div>
              <div class="over_screen_status_top" :style="{'left': overScreenLeft + 'px'}">
              <ArrowItem :itemWidth='0-screenStatus.top' color='#6666ff' isVertical=true v-if="screenStatus.top < 0"></ArrowItem>
              </div>
              <SimpleScreenItem :width="screenWidth" :height="screenStatusHeight" :border-color="'#ffffff'" :border-width=0></SimpleScreenItem>
              <!-- <el-image class='screenImg no-select' fit="fill" :src="require('@/assets/parts/simple/screen.png')" :style="{height:screenStatusHeight + 'px', width: screenWidth + 'px'}"></el-image>
              <div class="xiexian" :class="{'xiexian1' : aspectRatio === '16:9','xiexian2' : aspectRatio === '4:3','xiexian3' : aspectRatio === '16:6','xiexian4' : aspectRatio === '21:9','xiexian5' : aspectRatio === '2.35:1'}">
                <ArrowItem :itemWidth='Math.sqrt(Math.pow(screenWidth,2) + Math.pow(screenStatusHeight,2))' color='#ff3399' isVertical=true isScreenSize=true></ArrowItem>
              </div> -->
              <div class="screenHeightBgBottom" :style="{height:InitScreenHeight + 'px', width: screenWidth + 'px'}" v-if="floorB < 0"></div>
              <div class="over_screen_status_bottom" :style="{'left' : overScreenLeft + 'px'}" v-if="floorB < 0">
                <ArrowItem :itemWidth='0-floorToBottom' color='#ffff00' isVertical=true isBottomFix=true></ArrowItem>
              </div>
            </div>
            <div class="project-top-v-arrow-l" v-if="position === 1">
              <ProjectArrowItem :PjItemWidth='screenStatus.height' color= '#ff3399' isVertical=true LisVertical=true></ProjectArrowItem>
            </div>
            <div class="project-bottom-w-arrow" v-if="position === 1">
              <ProjectArrowItem color= '#ff3399' :PjItemWidth='PjscreenWidth'></ProjectArrowItem>
            </div>
        </div>
        <div class="panel-box">
          <div class="panel-box-line" :style="{'width': PJBoxLeft + 'px'}">
            <div class="pj1_container" ref="pjBox" :style="{'background': 'url('+ imgSrc +') no-repeat','background-position-x': '50%', 'background-position-y': backImgTransTop, 'background-size': ' 90px', 'top': PJBoxTop + 'px'}">
            </div>
            <div class="x-arrow-x v-arrow-x" @mousedown="onVMouseDownX" @mouseenter="onMouseEnLeft" @mouseleave="onMouseOutLeft" ref="pjarrow" :style="{'top': PJBoxTop + 30 + 'px'}"></div>
            <div class="arrow-bottom" :style="{'height': arrowBottomTop + 'px'}">
              <div class="leftArrow arrow" style="border-bottom-color: #ed843d;"></div>
              <div class="rightArrow arrow" style="border-top-color: #ed843d;"></div>
            </div>
          </div>
          <div class="x-arrow v-arrow" @mousedown="onVMouseDown" @mouseenter="onMouseEnDown" @mouseleave="onMouseOutDown" ref="pjarrow" :style="{'top': PJBoxTop + 'px', 'left': PJBoxLeft + 60 + 'px'}"></div>
          <div class="arrow-left" :style="{'width': PJBoxLeft - 554 / 2 - 12 + 'px'}">
            <div class="leftArrow-x arrow"></div>
            <div class="rightArrow-x arrow"></div>
          </div>
        </div>
        <div class="octagonimage" :class="{'celing-octagonimage' : position !== 0}" :style="{height:octagonHeight + 'px', width: octagonWidth + 'px',top:octagonTop +'px'}" v-show="lensShiftRangeBool" v-if="screen4Point !== null">
          <div class="octangon-up-arrow">
            <ArrowItem :itemWidth='octangonUp' isVertical=true color='#000000'></ArrowItem>
          </div>
          <div class="octangon-horizontal-arrow-l" :style="{top:octangonHorizontalTop + 'px'}">
            <ArrowItem :itemWidth='octangonHorizontal' isHorizontalVertical=true color='#000000'></ArrowItem>
          </div>
           <el-image fit="fill" :src="require('@/assets/parts/simple/' + octagonImg + '.png')" v-if="octagonImg === '' ? false : true" :style="{height:octagonHeight + 'px', width: octagonWidth + 'px'}"></el-image>
          <div class="octangon-down-arrow">
            <ArrowItem :itemWidth='octangonDown' isDownVertical=true color='#000000'></ArrowItem>
          </div>
           <div class="octangon-horizontal-arrow-r" :style="{top:octangonHorizontalTop + 'px'}">
            <ArrowItem :itemWidth='octangonHorizontal' isHorizontalH=true color='#000000'></ArrowItem>
          </div>
        </div>
        <div class="screen-top-to-ceiling-arrow">
          <ArrowItem :itemWidth='Math.abs(screenStatus.top)' color='#6666ff' isVertical=true v-if="screenStatus.top > 0"></ArrowItem>
        </div>
        <div class="screen-bottom-to-floor-arrow">
          <ArrowItem :itemWidth='Math.abs(floorToBottom)' color='#ffff00' isVertical=true isBottomFix=true v-if="floorB > 0"></ArrowItem>
        </div>
      </div>
      <img src="@/assets/parts/simple/people.png" class="man" :style="{height: manImgHeight + 'px'}" v-if="selectedModelData.category!==5" />
      <div class="yuan" v-show="brightnessGuide">
        <div class="yuan-val">{{brightnessData | filterToFix1}} nit</div>
        <div class="yuan-title">{{$t(brightnessTitle)}}</div>
        <img src="@/assets/parts/simple/brightness_bg.png">
        <div class="pointer" :style="{transform:'rotate('+ transVal + 'deg)'}">
          <img src="@/assets/parts/simple/brightness_arrow.png">
        </div>
      </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import ArrowItem from '../Simple/simpleArrow'
import ProjectArrowItem from '../Simple/simpleProjectArrow'
import SimpleScreenItem from '../Simple/simpleScreenItem'
export default {
  name: 'simpleProjectView',
  data () {
    return {
      topOffset: 24,
      frontWallWidth: 554,
      screnTop: 26,
      lineLeftWidth: 4,
      frontWallHeight: 191,
      transVal: 0,
      PjBoxWidth: '',
      pjBoxHeights: '',
      top: 0,
      imgSrc: require('@/assets/parts/simple/simpleui_projector.png'),
      scale: 1,
      distance: 0,
      lengthUpFloor: 0,
      PJBoxTop: 0,
      PJBoxLeft: 350,
      mouseDownFlag: false,
      moveTime: 0,
      mouseLeftFlag: false
    }
  },

  props: ['screenStatus', 'blueImgHeight', 'manImgHeight'],

  components: {ArrowItem, ProjectArrowItem, SimpleScreenItem},

  computed: {
    ...mapState([
      'graph',
      'houseInfo',
      'SimplePjTop',
      'offset',
      'USTVDragFlag',
      'fingerTouchStatus',
      'selectedModelData',
      'selectedLensData',
      'floor2bottom',
      'drawData',
      'position',
      'cateRadio',
      'lensShiftRangeBool',
      'initScreenSize',
      'screen4Point',
      'gain',
      'brightnessGuide',
      'selectRatioData',
      'aspectRatio',
      'screenSize',
      'throwDisSlidertFormat',
      'throwDisSliderwFormat',
      'modeData',
      'vLensShiftNow'
    ]),
    ...mapGetters(['unitLabel']),
    pjY () {
      return this.graph.pjY
    },

    pjZ () {
      return this.graph.pjZ
    },

    ceilingHFixed () {
      return this.$parent.ceilingHFixed
    },

    screenWidth () {
      let width = this.graph.scrnW * this.ceilingHFixed / this.houseInfo.roomH
      return width >= this.frontWallWidth ? this.frontWallWidth : width
    },
    floorToBottom () {
      return this.floor2bottom * this.ceilingHFixed / this.houseInfo.roomH
    },
    distanceFloorToBottom () {
      // console.log(42 * this.PjBoxHeight)
      // console.log('this.SimplePjTop', this.SimplePjTop)
      // let BoxHeight = 42 * this.PjBoxHeight
      // let FloorToBottom = this.ceilingHFixed - this.SimplePjTop - BoxHeight
      if (this.$store.state.selectedModelData.lensExchange && this.selectedLensData.id.indexOf('LX') > -1) {
        return this.floor2footProjector * this.ceilingHFixed / this.houseInfo.roomH + 14
      } else {
        // if (this.houseInfo.roomH < 400) {
        //   console.log(this.floor2footProjector * this.ceilingHFixed / this.houseInfo.roomH)
        //   return this.floor2footProjector * this.ceilingHFixed / this.houseInfo.roomH + 8
        // } else {
        return this.floor2footProjector * this.ceilingHFixed / this.houseInfo.roomH
        // }
      }
      // console.log('FloorToBottom', FloorToBottom)
      // return FloorToBottom + 24
    },
    floor2footProjector () {
      let BrightnessDataFe = this.getBrightnessFe
      let f2l = this.houseInfo.roomH - this.graph.pjZ < 0 ? 0 : this.houseInfo.roomH - this.graph.pjZ
      if (this.selectedModelData.lensExchange === true) {
        let f2foot = f2l - BrightnessDataFe
        return f2foot > 0 ? f2foot : 0
      } else {
        let f2foot = f2l - this.selectedLensData.fe
        return f2foot > 0 ? f2foot : 0
      }
    },
    getBrightnessFe () {
      let brightnessfe
      let lensExchange = this.selectedModelData.lensExchange
      if (lensExchange) {
        let code = this.selectedModelData.code
        let lensId = this.selectedLensData.id
        for (let i = 0; i < this.Brightness.optionLens.length; i++) {
          if (this.Brightness.optionLens[i].code === code && this.Brightness.optionLens[i].lensId === lensId) {
            brightnessfe = this.Brightness.optionLens[i].fe / 10
          }
        }
      }
      return brightnessfe
    },
    screenStatusTop () {
      if (this.screenStatus.top < 0) {
        if (this.position === 0) {
          return this.screenStatus.top - this.screnTop
        } else {
          return this.screenStatus.top
        }
      } else {
        if (this.position === 0) {
          return this.screenStatus.top - this.screnTop
        } else {
          return this.screenStatus.top
        }
      }
    },

    octagonImg () {
      return this.$commonJs.octagon()
    },

    PjscreenWidth () {
      return this.screenWidth - this.lineLeftWidth
    },
    octangonUp () {
      if (this.graph.vLensShift.min > 0 && this.graph.hLensShift.max !== this.graph.hLensShift.min) {
        let initScreenH = (this.initScreenSize.h - this.graph.scrnH) / 2
        return this.octagonHeight - this.graph.scrnH * this.ceilingHFixed / this.houseInfo.roomH - initScreenH * this.ceilingHFixed / this.houseInfo.roomH
      } else if (this.graph.vLensShift.min > 0 && this.graph.hLensShift.max === this.graph.hLensShift.min) {
        return this.graph.scrnH * (this.graph.vLensShift.max - this.graph.vLensShift.min) * this.ceilingHFixed / this.houseInfo.roomH
      } else {
        return (this.octagonHeight - this.graph.scrnH * this.ceilingHFixed / this.houseInfo.roomH) / 2
      }
    },
    octangonDown () {
      if (this.graph.vLensShift.min > 0 && this.graph.hLensShift.max !== this.graph.hLensShift.min) {
        return this.octagonHeight - this.graph.scrnH * this.ceilingHFixed / this.houseInfo.roomH - this.octangonUp + 14
      } else {
        return Math.abs(this.octagonHeight - this.graph.scrnH * this.ceilingHFixed / this.houseInfo.roomH) / 2
      }
    },
    octangonHorizontal () {
      let horizontalW = this.initScreenSize.w * this.graph.hLensShift.max * this.ceilingHFixed / this.houseInfo.roomH
      let oldHorizontalW = this.initScreenSize.w * this.ceilingHFixed / this.houseInfo.roomH
      let newHorizontalW = (oldHorizontalW - this.screenWidth) / 2
      return horizontalW + newHorizontalW
    },
    octangonHorizontalTop () {
      if (this.position !== 0) {
        return this.octagonHeight / 2 - this.screnTop / 2 + 20
      } else {
        return this.octagonHeight / 2 - this.screnTop / 2 - 20
      }
    },
    octagonHeight () {
      let initOctagonH = this.initScreenSize.h * (this.graph.vLensShift.max - this.graph.vLensShift.min) * this.ceilingHFixed / this.houseInfo.roomH
      let MaxOctagonH = this.initScreenSize.h * this.graph.vLensShift.max * this.ceilingHFixed / this.houseInfo.roomH
      let MinOctagonH = this.initScreenSize.h * this.graph.vLensShift.min * this.ceilingHFixed / this.houseInfo.roomH
      let initScreenSizeH = this.initScreenSize.h * this.ceilingHFixed / this.houseInfo.roomH
      if (this.graph.vLensShift.min > 0 && this.graph.hLensShift.max !== this.graph.hLensShift.min) {
        return initOctagonH + initScreenSizeH + this.screnTop
      } else if (this.graph.vLensShift.min > 0 && this.graph.hLensShift.max === this.graph.hLensShift.min) {
        return initScreenSizeH + initOctagonH
      } else {
        return initScreenSizeH + MaxOctagonH + Math.abs(MinOctagonH)
      }
    },
    octagonWidth () {
      if (this.graph.vLensShift.min > 0 && this.graph.hLensShift.max === this.graph.hLensShift.min) {
        return this.initScreenSize.w * this.ceilingHFixed / this.houseInfo.roomH
      } else {
        let MaxOctagonW = this.initScreenSize.w * this.graph.hLensShift.max * this.ceilingHFixed / this.houseInfo.roomH
        let initScreenSizeW = this.initScreenSize.w * this.ceilingHFixed / this.houseInfo.roomH
        return initScreenSizeW + MaxOctagonW * 2
      }
    },
    octagonTop () {
      if (this.position !== 0 && this.graph.vLensShift.max < 0 && this.graph.hLensShift.max !== this.graph.hLensShift.min) {
        return this.screenStatusTop
      } else {
        let initOctagonT = this.initScreenSize.h * (this.graph.vLensShift.max - this.graph.vLensShift.min) * this.ceilingHFixed / this.houseInfo.roomH
        let screen4PointTop = (this.screen4Point[0].z * this.ceilingHFixed) / this.houseInfo.roomH > this.ceilingHFixed ? this.ceilingHFixed : (this.screen4Point[0].z * this.ceilingHFixed) / this.houseInfo.roomH
        let UpTop = screen4PointTop - 14
        let MaxOctagonH = this.initScreenSize.h * this.graph.vLensShift.max * this.ceilingHFixed / this.houseInfo.roomH
        if (this.graph.vLensShift.min > 0 && this.graph.hLensShift.max !== this.graph.hLensShift.min) {
          return UpTop - initOctagonT - this.screnTop / 2
        } else if (this.graph.vLensShift.min > 0 && this.graph.hLensShift.max === this.graph.hLensShift.min) {
          return UpTop - initOctagonT + this.screnTop / 2
        } else {
          return UpTop - MaxOctagonH + this.screnTop / 2
        }
      }
    },
    SimplePjTops: {
      get () {
        return this.SimplePjTop
      },
      set (val) {
        this.SET_SIMPLEPJTOP(val)
      }
    },
    InitHeight () {
      let InitH = this.graph.scrnH * this.ceilingHFixed / this.houseInfo.roomH
      let screenStatusH = InitH - this.screenStatus.height
      return screenStatusH.toFixed(3)
    },

    overScreenLeft () {
      return this.screenWidth / 2 + this.screnTop / 2
    },

    InitScreenHeight () {
      let newPoinet = this.drawData[0]
      if (this.screenStatus.top < 0) {
        return Math.abs(newPoinet[0].z) * this.ceilingHFixed / this.houseInfo.roomH
      } else {
        return (newPoinet[3].z - this.houseInfo.roomH) * this.ceilingHFixed / this.houseInfo.roomH
      }
    },
    screenStatusHeight () {
      return this.screenStatus.height
    },
    floorB () {
      return this.floor2bottom
    },
    StatusHeight () {
      // if (this.position === 0) {
      //   return this.screenStatus.height + this.screnTop
      // } else if (this.position === 1) {
      //   return this.screenStatus.height
      // }
      return this.screenStatus.height
    },
    screenBottom () {
      return 0 - this.InitHeight
    },
    brightnessData () {
      let b = this.$commonJs.brightnessCoefficient()
      return b * this.gain / (this.graph.scrnW * this.graph.scrnH * Math.PI / 10000)
    },
    brightnessTitle () {
      let brightnessVal = Math.round(this.brightnessData)
      if (this.cateRadio === 'bmRadio') {
        if (brightnessVal > 0 && brightnessVal < 151) {
          return 'T_SIMPLEUI_BRIGHTNESS_INDICATOR_MSG3'
        } else if (brightnessVal > 150 && brightnessVal < 301) {
          return 'T_SIMPLEUI_BRIGHTNESS_INDICATOR_MSG2'
        } else if (brightnessVal > 300) {
          return 'T_SIMPLEUI_BRIGHTNESS_INDICATOR_MSG1'
        }
      } else {
        if (brightnessVal > 0 && brightnessVal < 51) {
          return 'T_SIMPLEUI_BRIGHTNESS_INDICATOR_MSG3'
        } else if (brightnessVal > 50 && brightnessVal < 301) {
          return 'T_SIMPLEUI_BRIGHTNESS_INDICATOR_MSG5'
        } else if (brightnessVal > 300) {
          return 'T_SIMPLEUI_BRIGHTNESS_INDICATOR_MSG4'
        }
      }
    },

    YingScreenSize () {
      let MaxRoomCeilingHeight = 363 * this.scale
      let MinRoomCeilingHeight = 0
      let MaxScale = 1.8
      let MinScale = 1.4
      let bili = (MaxRoomCeilingHeight - MinRoomCeilingHeight) / (MaxScale - MinScale) / 10
      return (MinScale + (MaxRoomCeilingHeight - this.SimplePjTops) * 0.1 / bili) * this.PjBoxHeight * this.scale
    },
    YingOpacity () {
      let MaxRoomCeilingHeight = 363 * this.scale
      let MinRoomCeilingHeight = 0
      let MaxScale = 0
      let MinScale = 0.8
      let bili = (MaxRoomCeilingHeight - MinRoomCeilingHeight) / (MaxScale - MinScale) / 10
      return MinScale + (MaxRoomCeilingHeight - this.SimplePjTops) * 0.1 / bili
    },
    PjBoxHeight () {
      let MaxScale = 0.6
      let MinScale = 0
      let Scalebili = (MaxScale - MinScale) / (2000 - 200) / 10
      return MaxScale - (this.houseInfo.roomH - 200) / 0.1 * Scalebili
    },

    backImgTransTop () {
      let top = this.graph.pjZ * this.ceilingHFixed / this.houseInfo.roomH
      let n = Math.floor(top / (this.ceilingHFixed / 20))
      return -38 * n + 1 + 'px'
    },
    PJBoxRight () {
      let MaxRight = 90
      let MinRight = 130
      let RightBili = (MinRight - MaxRight) / (2000 - 200) / 10
      return MaxRight - (200 - this.houseInfo.roomH) / 0.1 * RightBili
    },

    arrowBottomTop () {
      let height = 0
      if (document.getElementsByClassName('pj1_container')[0]) {
        height = document.getElementsByClassName('pj1_container')[0].getClientRects()[0].height
      }
      return 363 - this.PJBoxTop - height < 0 ? 0 : 363 - this.PJBoxTop - height
    }
  },

  filters: {
    filterToFix1 (value) {
      return Math.round((value * 1))
    }
  },

  watch: {
    brightnessData (newVal, oldVal) {
      this.getTransVal(newVal)
    },
    SimplePjTops () {
      if (this.SimplePjTop === 0 && this.selectedModelData.modelSeries !== 'BoliviaUSTH') {
        if (this.position === 0) this.SET_VLENSSHIFT(this.vLensShiftNow * -1)
        this.SET_POSITION(1)
      }
      if (this.SimplePjTop === this.ceilingHFixed) {
        if (this.position === 1) this.SET_VLENSSHIFT(this.vLensShiftNow * -1)
        this.SET_POSITION(0)
      }
    },

    pjY (newVal) {
      let min, max
      if (this.modeData === '0') {
        max = this.throwDisSlidertFormat
        min = this.throwDisSliderwFormat
      } else {
        let temp1 = this.$commonViewJs.getMinDisByLens()
        let temp2 = this.$commonViewJs.getMaxDisByRoom()
        min = temp1.minDis
        max = temp1.maxDis < temp2 ? temp1.maxDis : temp2
      }
      let minPx = 350
      if (max === min) {
        this.PJBoxLeft = 350
      } else {
        this.PJBoxLeft = (newVal - min) / ((max - min) / (554 - minPx)) + minPx
      }
    }
  },

  mounted () {
    this.init()
    this.PjBoxWidth = this.$refs['pjBox'].offsetWidth
    this.pjBoxHeights = this.$refs['pjBox'].offsetHeight
    this.PJBoxTop = this.graph.pjZ * this.ceilingHFixed / this.houseInfo.roomH
    window.addEventListener('keydown', this.handleKeyDown, false)
    window.addEventListener('keyup', this.handelKeyUp, false)
  },

  methods: {
    ...mapMutations(['SET_SIMPLEPJTOP', 'PJZ', 'PJY', 'SCREENSIZE', 'SCRNW', 'SCRNH', 'SET_POSITION', 'SET_VLENSSHIFT']),
    init () {
      this.getTransVal()
    },
    getTransVal () {
      let MaxScreenW = this.selectRatioData.screenSize.w.max
      let MinScreenW = this.selectRatioData.screenSize.w.min
      this.transVal = 90 / (MaxScreenW - MinScreenW) * (this.screenSize - MinScreenW) - 4
    },
    onVMouseDown (e) {
      // event的兼容性
      let ev = e || event
      ev.preventDefault()
      // 获取鼠标按下的坐标
      let oldY = ev.clientY
      let _that = this
      document.onmousemove = ev => {
        // event的兼容性
        let e = ev || event
        // 获取鼠标移动时的坐标
        let newY = e.clientY
        // 计算出鼠标的Y方向移动距离
        let moveY = newY - oldY
        // 获取元素的top值
        _that.PJBoxTop += moveY
        if (_that.PJBoxTop < 0) {
          _that.PJBoxTop = 0
        }
        if (_that.PJBoxTop > this.ceilingHFixed) {
          _that.PJBoxTop = this.ceilingHFixed
        }
        let pjzVal = _that.PJBoxTop * this.houseInfo.roomH / this.ceilingHFixed
        this.PJZ(pjzVal)
        oldY = newY
      }
      // 清除
      document.onmouseup = ev => {
        document.onmousemove = null
      }
    },

    onVMouseDownX (e) {
      // event的兼容性
      let ev = e || event
      ev.preventDefault()
      let oldX = ev.clientX
      let _that = this
      let min, max
      if (this.modeData === '0') {
        max = this.throwDisSlidertFormat
        min = this.throwDisSliderwFormat
      } else {
        let temp1 = this.$commonViewJs.getMinDisByLens()
        let temp2 = this.$commonViewJs.getMaxDisByRoom()
        min = temp1.minDis
        max = temp1.maxDis < temp2 ? temp1.maxDis : temp2
      }
      let minPx = 350
      document.onmousemove = ev => {
        if (min === max) {
          return
        }
        // event的兼容性
        let e = ev || event
        // 获取鼠标移动时的坐标
        let newX = e.clientX
        // 计算出鼠标的Y方向移动距离
        let moveX = newX - oldX
        // 获取元素的top值
        _that.PJBoxLeft += moveX
        if (_that.PJBoxLeft > 554) {
          _that.PJBoxLeft = 554
        }
        if (_that.PJBoxLeft < minPx) {
          _that.PJBoxLeft = minPx
        }
        // let pjyVal = _that.PJBoxLeft * this.houseInfo.roomH / this.ceilingHFixed
        let pjyVal = (max - min) / (554 - minPx) * (_that.PJBoxLeft - minPx) + min
        this.PJY(pjyVal)
        oldX = newX
      }
      // 清除
      document.onmouseup = ev => {
        document.onmousemove = null
      }
    },

    onMouseEnDown () {
      this.mouseDownFlag = true
    },
    onMouseOutDown () {
      this.mouseDownFlag = false
    },
    onMouseEnLeft () {
      this.mouseLeftFlag = true
    },
    onMouseOutLeft () {
      this.mouseLeftFlag = false
    },

    mouseMoveData (moveData) {
      // 左
      if (this.mouseLeftFlag) {
        let min, max
        if (this.modeData === '0') {
          max = this.throwDisSlidertFormat
          min = this.throwDisSliderwFormat
        } else {
          let temp1 = this.$commonViewJs.getMinDisByLens()
          let temp2 = this.$commonViewJs.getMaxDisByRoom()
          min = temp1.minDis
          max = temp1.maxDis < temp2 ? temp1.maxDis : temp2
        }

        let dis = moveData
        dis = dis < min ? min : (dis > max ? max : dis)
        this.PJY(dis)
      } else if (this.mouseDownFlag) {
        this.PJZ(moveData)
        this.PJBoxTop = this.graph.pjZ * this.ceilingHFixed / this.houseInfo.roomH
      }
    },

    // 键盘事件
    handleKeyDown (e) {
      if (e.keyCode > 36 && e.keyCode < 41 && (this.mouseLeftFlag || this.mouseDownFlag)) { e.preventDefault() }
      let newTime = new Date().getTime()
      if (newTime - this.moveTime < 500) {
        return
      }
      this.moveTime = new Date().getTime()
      let moveLim = this.$commonJs.getMoveDisByUnit()
      if (e.keyCode === 37) {
        // 左
        if (this.mouseLeftFlag) {
        //   let min, max
        //   if (this.modeData === '0') {
        //     max = this.throwDisSlidertFormat
        //     min = this.throwDisSliderwFormat
        //   } else {
        //     let temp1 = this.$commonViewJs.getMinDisByLens()
        //     let temp2 = this.$commonViewJs.getMaxDisByRoom()
        //     min = temp1.minDis
        //     max = temp1.maxDis < temp2 ? temp1.maxDis : temp2
        //   }

        //   let dis = this.pjY - moveLim
        //   dis = dis < min ? min : (dis > max ? max : dis)
        //   this.PJY(dis)
          this.mouseMoveData(this.pjY - moveLim)
        }
      } else if (e.keyCode === 38) {
        // 上
        if (this.mouseDownFlag) {
          this.mouseMoveData(this.pjZ - moveLim)
          // this.PJZ(this.pjZ - moveLim)
          // this.PJBoxTop = this.graph.pjZ * this.ceilingHFixed / this.houseInfo.roomH
        }
      } else if (e.keyCode === 39) {
        // 右
        if (this.mouseLeftFlag) {
        //   let min, max
        //   if (this.modeData === '0') {
        //     max = this.throwDisSlidertFormat
        //     min = this.throwDisSliderwFormat
        //   } else {
        //     let temp1 = this.$commonViewJs.getMinDisByLens()
        //     let temp2 = this.$commonViewJs.getMaxDisByRoom()
        //     min = temp1.minDis
        //     max = temp1.maxDis < temp2 ? temp1.maxDis : temp2
        //   }

        //   let dis = this.pjY + moveLim
        //   dis = dis < min ? min : (dis > max ? max : dis)
        //   this.PJY(dis)
          this.mouseMoveData(this.pjY + moveLim)
        }
      } else if (e.keyCode === 40) {
        // 下
        if (this.mouseDownFlag) {
          this.mouseMoveData(this.pjZ + moveLim)
          // 简易图中上下箭头
          // this.PJZ(this.pjZ + moveLim)
          // this.PJBoxTop = this.graph.pjZ * this.ceilingHFixed / this.houseInfo.roomH
        }
      }
    },

    handelKeyUp () {
      this.moveTime = 0
    },

    setPosition () {
      // 以下代码投影仪角度用
      // this.PJBoxTop = this.graph.pjZ * this.ceilingHFixed / this.houseInfo.roomH
      // this.PJBoxTop = this.ceilingHFixed - (this.floor2footProjector)
      // let top = this.graph.pjZ * this.ceilingHFixed / this.houseInfo.roomH
      // this.$refs['pjBox'].style.top = top + 'px'
      // this.$refs['pjarrow'].style.top = top + 'px'
    }
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.handleKeyDown, false)
    window.removeEventListener('keyup', this.handelKeyUp, false)
  }
}

</script>
<style scoped>
/* 以下代码投影仪角度用 */
.poistion-liner {
    /* margin: 0 auto; */
    position: absolute;
    left: 50%;
    /* top: 100%; */
}

.pj1_box {
  position: absolute;
  z-index: 555;
  transform: translateX(-50%);
}

.pj1_container {
  position: absolute;
  z-index: 555;
  height: 30px;
  right: 0;
  overflow: hidden;
  transform: rotateX(0deg) rotateY(70deg) translateX(0%);
  -moz-transform: rotateX(0deg) rotateY(70deg) translateX(0%);
  transform-style:preserve-3d;
  -moz-transform-style:preserve-3d;
  background-size: 90px;
  width: 90px;
}

.x-arrow {
  background: url("../../../assets/parts/simple/btn_move.png") no-repeat;
  background-size: 23px 65px;
  width: 23px;
  height: 65px;
}

.x-arrow:hover {
  background: url("../../../assets/parts/simple/btn_move_hover.png") no-repeat;
  background-size: 23px 65px;
  cursor: pointer;
}

.x-arrow-x {
  background: url("../../../assets/parts/simple/btn_move-x.png") no-repeat;
  width: 65px;
  height: 23px;
  background-size: 65px 23px;
}

.x-arrow-x:hover {
  background: url("../../../assets/parts/simple/btn_move_hover-x.png") no-repeat;
  cursor: pointer;
  background-size: 65px 23px;

}

.v-arrow {
  position: absolute;
  left: 70%;
  top: 10px;
  z-index: 555;
  transform:rotateX(0deg) rotateY(70deg);
  -moz-transform: rotateX(0deg) rotateY(70deg);
  transform-style:preserve-3d;
  -moz-transform-style:preserve-3d;
}

.v-arrow-x {
  position: absolute;
  right: 0;
  top: 10px;
  z-index: 555;
  transform:rotateX(0deg) rotateY(0deg) translateX(50%) translateZ(30px);
  -moz-transform:rotateX(0deg) rotateY(0deg) translateX(50%) translateZ(30px);
  transform-style:preserve-3d;
  -moz-transform-style:preserve-3d;
}

.h-arrow {
  position: absolute;
  bottom: 0px;
  left: 30px;
}

.screen {
  position: absolute;
  width: 400px;
  left: 276px;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  z-index: 222;
}

.screen-top-to-ceiling-arrow {
  position: absolute;
  left: 290px;
  top: 7px;
}

.screen-bottom-to-floor-arrow {
  position: absolute;
  bottom: 8px;
  left: 290px;
}

.project-bottom-to-floor-arrow {
  position: absolute;
  left: 560px;
  bottom: 255px;
  z-index: 333;
}

.project-top-v-arrow-r {
  position: absolute;
  right: -26px;
  top: 0;
}

.project-top-v-arrow-l {
  position: absolute;
  top: 0;
  left: 0;
}

.project-bottom-w-arrow {
  position: absolute;
  bottom: -26px;
  left: 0;
}

.throw-pj-arrow {
  position: absolute;
  left: 50%;
  z-index: 444;
  bottom: 0;
  transform: translateY(100%);
}

.no-select {
  user-select: none;
}

.front-wall {
  position: absolute;
  height: 363px;
  top: 239px;
  left: 182px;
}

.man {
  position: absolute;
  left: 200px;
  bottom: 280px;
  z-index: 222;
}

.octagonimage {
  position: absolute;
  left: 276px;
  transform: translateX(-50%);
}

.celing-octagonimage {
  transform: translateX(-50%) scaleY(-1);
}

.octangon-up-arrow {
  position: absolute;
  top: 7px;
  left: 35%;
}

.octangon-down-arrow {
  position: absolute;
  left: 8%;
  bottom: 7px;
}

.octangon-horizontal-arrow-l {
  position: absolute;
  left: 7px;
}

.octangon-horizontal-arrow-r {
  position: absolute;
  right: 7px;
}

.arrow {
  position: relative;
}

.screenHeightBg {
  background: rgba(183, 183, 183, 0.5);
  position: absolute;
  left: 0px;
  z-index: 222;
}

.screenHeightBgTop {
  top: 26px;
}

.yuan {
  position: absolute;
  bottom: -4px;
  left: 0;
  z-index: 555;
}

.yuan-val {
  position: absolute;
  top: 90px;
  left: 20px;
  color: #fff;
  font-size: 24px;
  text-decoration:underline
}

.yuan-title {
  position: absolute;
  top: 130px;
  left: 20px;
  color: #fff;
  max-width: 145px;
  font-size: 14px;
}

.pointer {
  position: absolute;
  top: 10px;
  left: 0;
  transform: rotate(0deg);
  transform-origin: bottom left;
  height: 92%;
}

.screenHeightBgBottom {
  background: rgba(183, 183, 183, 0.5);
  position: absolute;
  left: 0px;
  bottom: 4px;
  z-index: 222;
}

.screen-bg {
  position: relative;
}

.over_screen_status_top {
  position: absolute;
  top: 7px;
  z-index: 222;
}

.over_screen_status_bottom {
  position: absolute;
  bottom: 10px;
  z-index: 222;
}

.touying {
  background: url('../../../assets/parts/simple/img_P_projection.png') no-repeat;
  position: absolute;
  width: 240px;
  height: 60px;
  z-index: 333;
}

.xiexian {
  position: absolute;
  transform: rotate(-58deg);
  top: -19px;
  left: 34px;
  transform-origin: bottom left;
}

.xiexian1 {
  transform: rotate(-61deg);
  top: -20px;
  left: 34px;
}

.xiexian2 {
  transform: rotate(-54deg);
  top: -16px;
  left: 33px;
}
.xiexian3 {
  transform: rotate(-71deg);
  top: -25px;
  left: 33px;
}
.xiexian4 {
  transform: rotate(-68deg);
  top: -23px;
  left: 33px;
}
.xiexian5 {
  transform: rotate(-67.5deg);
  top: -24px;
  left: 33px;
}

.leftArrow {
  width: 0;
  height: 0;
  border-width: 6px;
  border-style: solid;
  border-color:transparent;
  border-bottom-color: inherit;
  top: -6px;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
}
.rightArrow {
  width: 0;
  height: 0;
  border-width: 6px;
  border-style: solid;
  border-color:transparent;
  border-top-color: inherit;
  bottom: -6px;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 50%);
}
.leftArrow-x {
  width: 0;
  height: 0;
  border-width: 6px;
  border-style: solid;
  border-color:transparent;
  border-right-color: #00b0f0;
  left: -6px;
  top: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}
.rightArrow-x {
  width: 0;
  height: 0;
  border-width: 6px;
  border-style: solid;
  border-color:transparent;
  border-left-color: #00b0f0;
  right: -6px;
  top: 50%;
  position: absolute;
  transform: translate(50%, -50%);
}
.middle {
  width: 4px;
  position: relative;
}

.panel-box {
  width: 100%;
  height: 100%;
  transform:perspective(800px) rotateX(0deg) rotateY(-70deg);
  -moz-transform:perspective(800px) rotateX(0deg) rotateY(-70deg);
  -moz-transform-style:preserve-3d;
  transform-style:preserve-3d;
  position: absolute;
  z-index: 999;
}

.panel-box-line {
  position: relative;
  width: 80%;
  height: 100%;
  -moz-transform-style:preserve-3d;
  transform-style:preserve-3d;
}

.arrow-bottom {
  width: 4px;
  background: #ed843d;
  position: absolute;
  right: 0;
  bottom: 6px;
  transform:rotateX(0deg) rotateY(70deg);
  -moz-transform-style:preserve-3d;
  transform-style:preserve-3d;
}

.arrow-left {
  height: 4px;
  position: absolute;
  left: 277px;
  background: #00b0f0;
  bottom: 0;
  transform:rotateX(0deg) rotateY(0deg);
  transform-style: preserve-3d;
}
</style>



// WEBPACK FOOTER //
// src/view/graph/Simple/simpleProjectView.vue